import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Alert,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import axios from "axios";
import { useNavigate } from "react-router-dom";

// Assets
import logo from "../asserts/logo/Logo.svg";
import icon from "../asserts/logo/Icon.svg";
import curveShield from "../asserts/logo/curve-shield.svg";
import curveFlow from "../asserts/logo/curve-flow.svg";


// RESPONSIVE FULLSCREEN BACKGROUND
const FullBlueScreen = {
  width: "100vw",
  height: "100vh",
  position: "fixed",
  top: 0,
  left: 0,
  background:
    "radial-gradient(78.17% 184.46% at 71.19% 20.85%, #0A90FC 0%, #172950 100%)",
  overflow: "hidden",
};


function Login() {
  const [formValues, setFormValues] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState("");
  const [severity, setSeverity] = useState("error");

  const navigate = useNavigate();


  // TEXTFIELD CHANGE HANDLER
  const handleInputChange = (event) => {
    const { id, value } = event.target;

    setFormValues({
      ...formValues,
      [id]: value,
    });

    setFormErrors({
      ...formErrors,
      [id]: value.trim() ? "" : formErrors[id],
    });
  };


  // CLICK LOGIN BUTTON
  const handleLogin = async (e) => {
    e.preventDefault();

    const username = formValues.username.trim();
    const password = formValues.password.trim();

    const errors = {};
    if (!username) errors["username"] = "Please enter username.";
    if (!password) errors["password"] = "Please enter password.";

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      const response = await axios.post("https://validaite.io/api/login", {
        username,
        password,
      });

      console.log("LOGIN SUCCESS:", response.data);

      if (response.data) {
        navigate("/projects");
      }

    } catch (error) {
      console.error("LOGIN ERROR:", error);
      setSeverity("error");
      setError("Login failed. Please check your credentials.");
    }
  };


  return (
    <Box sx={FullBlueScreen}>

      {/* FIGMA SHIELD - 30% OPACITY */}
      <Box
        component="img"
        src={curveShield}
        sx={{
          position: "fixed",
          width: { xs: "220px", sm: "280px", md: "340px", lg: "300px" },
          height: "auto",
          left: "480px",
          top: { xs: "30%", md: "35%", lg: "256px" },
          opacity: 0.3,
          pointerEvents: "none",
        }}
      />

      {/* FIGMA FLOW - 30% OPACITY */}
      <Box
        component="img"
        src={curveFlow}
        sx={{
          position: "fixed",
          width: { xs: "200px", sm: "260px", md: "320px", lg: "360px", xl: "420px" },
          height: "auto",
          // left: { xs: "40%", md: "45%", lg: "50%", xl: "754px" },
          left: "600px",
          top: { xs: "35%", md: "40%", lg: "286px" },
          opacity: 0.3,
          pointerEvents: "none",
        }}
      />

      {/* LEFT TEXT BLOCK - EXACT FIGMA */}
      <Box
        sx={{
          position: "fixed",
          left: { xs: "40px", md: "80px", lg: "97px" },
          top: { xs: "120px", md: "180px", lg: "214px" },
          width: { xs: "300px", md: "400px", lg: "500px" },
          color: "#FFF",
          display: { xs: "none", lg: "block" },
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Box component="img" src={icon} sx={{ width: 78, height: 78 }} />
        </Box>

        <Typography sx={{ 
          fontSize: "20px", 
          fontWeight: 400, 
          mb: 3, 
          lineHeight: "24px",
        }}>
          Trust First. Risk Aware. Enterprise Ready
        </Typography>

{/* Divider Line */}
<Box
  sx={{
    width: "440px",
    height: "1px",
    backgroundColor: "#D9D9D9",
    opacity: 0.3,
    mt: "16px",   // margin to position below text
    mb: "16px",   // spacing before QE-First
  }}
/>


       {/* QE-First Section */}
<Box sx={{ mt: 3 }}>
  {/* Line 1: QE - First (plain text, no blue box) */}
  {/* <Typography
    sx={{
      fontSize: "20px",
      fontWeight: 700,
      color: "#FFFFFF",
      lineHeight: "24px",
      mb: 2,
    }}
  >
    QE - First
  </Typography> */}

  {/* Line 2: AI Trust Engineering Platform Built for */}
  <Typography
    sx={{
      fontSize: "24px",
      fontWeight: 400,
      color: "#FFFFFF",
      lineHeight: "32px",
      mb: 0.5,
    }}
  >
    QE-First AI Trust Engineering Platform Built 
  </Typography>

  {/* Line 3: Enterprise IT. */}
  <Typography
    sx={{
      fontSize: "24px",
      fontWeight: 400,
      color: "#FFFFFF",
      lineHeight: "32px",
    }}
  >
    for Enterprise IT.
  </Typography>
</Box>

      </Box>




      {/* RIGHT WHITE PANEL - EXACT FIGMA WITH 24PX PADDING */}
      <Box
        sx={{
          position: "fixed",
          top: { xs: "50%", lg: "50%" },
          left: { xs: "50%", lg: "750px" },   // adjust this number
          transform: { xs: "translate(-50%, -50%)", lg: "translateY(-50%)" },
          width: { xs: "90%", sm: "400px", lg: "480px" },
          maxWidth: "480px",
          background: "#FFFFFF",
          borderRadius: "4px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          zIndex: 10,
          padding: "48px 40px",  // ⬅ EXACT FIGMA PADDING
    borderRadius: "8px",   // (Figma looks like ~8px)
        }}
      >


        {/* LOGO */}
        <Box sx={{ width: "100%", textAlign: "left", mb: "32px" }}>
          <Box
            component="img"
            src={logo}
            sx={{ 
              width: "auto", 
              height: "78px",
              maxWidth: "100%",
              objectFit: "contain",
              ml: "-28px",
            }}
          />
        </Box>

        <Typography sx={{ 
          fontSize: "32px", 
          fontWeight: 700, 
          mb: "8px", 
          textAlign: "left",
          color: "#1F2937",
          lineHeight: "36px"
        }}>
          Welcome!
        </Typography>

        <Typography sx={{ 
          color: "#9CA3AF", 
          mb: 3, 
          fontSize: "13px", 
          textAlign: "left",
          fontWeight: 400,
          lineHeight: "20px"
        }}>
          Please enter your details
        </Typography>


        {/* ERROR BOX */}
        {error && (
          <Alert severity={severity} sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}


        <Box component="form" onSubmit={handleLogin} sx={{ width: "100%" }}>
          {/* USERNAME */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{ 
              fontSize: "16px", 
              fontWeight: 500, 
              color: "#6B7280", 
              mb: 0.5 
            }}>
              Email ID
            </Typography>
            <TextField
              id="username"
              placeholder="Enter Email ID"
              fullWidth
              value={formValues.username}
              onChange={handleInputChange}
              error={!!formErrors.username}
              helperText={formErrors.username}
              sx={{ 
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  backgroundColor: "#F9FAFB",
                  "& fieldset": {
                    borderColor: "#E5E7EB",
                  },
                  "&:hover fieldset": {
                    borderColor: "#D1D5DB",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#0EA5E9",
                    borderWidth: "1px",
                  },
                },
                "& .MuiInputBase-input": {
                  padding: "10px 12px",
                  fontSize: "14px",
                  color: "#1F2937",
                  "&::placeholder": {
                    color: "#D1D5DB",
                    opacity: 1,
                  }
                }
              }}
            />
          </Box>

          {/* PASSWORD */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{ 
              fontSize: "13px", 
              fontWeight: 500, 
              color: "#6B7280", 
              mb: 0.5 
            }}>
              Password
            </Typography>
            <TextField
              id="password"
              placeholder="Enter password"
              fullWidth
              type={showPassword ? "text" : "password"}
              value={formValues.password}
              onChange={handleInputChange}
              error={!!formErrors.password}
              helperText={formErrors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => setShowPassword(!showPassword)} 
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ 
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  backgroundColor: "#F9FAFB",
                  "& fieldset": {
                    borderColor: "#E5E7EB",
                  },
                  "&:hover fieldset": {
                    borderColor: "#D1D5DB",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#0EA5E9",
                    borderWidth: "1px",
                  },
                },
                "& .MuiInputBase-input": {
                  padding: "10px 12px",
                  fontSize: "14px",
                  color: "#1F2937",
                  "&::placeholder": {
                    color: "#D1D5DB",
                    opacity: 1,
                  }
                }
              }}
            />
          </Box>

          {/* KEEP ME SIGNED IN + LOGIN BUTTON */}
          <Box sx={{ 
            display: "flex", 
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1
          }}>
            <FormControlLabel 
              control={
                <Checkbox 
                  size="small"
                  sx={{ 
                    padding: "4px",
                    color: "#D1D5DB",
                    "&.Mui-checked": {
                      color: "#0EA5E9",
                    }
                  }} 
                />
              } 
              label={
                <Typography sx={{ fontSize: "13px", color: "#6B7280", fontWeight: 400 }}>
                  Keep me signed in
                </Typography>
              }
              sx={{ margin: 0 }}
            />

            <Button
              type="submit"
              variant="contained"
              endIcon={<ArrowForwardIcon sx={{ fontSize: "16px" }} />}
              sx={{
                background: "#0EA5E9",
                borderRadius: "6px",
                textTransform: "none",
                px: 2,
                py: 0.75,
                fontSize: "14px",
                fontWeight: 500,
                boxShadow: "none",
                minWidth: "90px",
                "&:hover": { 
                  background: "#0284C7",
                  boxShadow: "none"
                },
              }}
            >
              Login
            </Button>
          </Box>

          <Box sx={{ textAlign: "right", mb: 3 }}>
            <Link
              underline="none"
              sx={{
                color: "#0EA5E9",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 400,
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              Forgot your password ?
            </Link>
          </Box>

          {/* FOOTER */}
          <Box sx={{ 
            textAlign: "center", 
            fontSize: "11px", 
            color: "#9CA3AF",
            lineHeight: "16px"
          }}>
            By signing in, you agree to our{" "}
            <Link href="#" underline="hover" sx={{ color: "#0EA5E9", fontWeight: 400 }}>
              Terms of Use
            </Link>
            {" "} & {" "}
            <Link href="#" underline="hover" sx={{ color: "#0EA5E9", fontWeight: 400 }}>
              Privacy Policy
            </Link>
          </Box>
        </Box>

      </Box>

    </Box>
  );
}

export default Login;

// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Alert,
//   Checkbox,
//   FormControlLabel,
//   Link,
// } from "@mui/material";
// import { styled } from "@mui/system";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import { login } from "../services/webServices";
// import { useNavigate } from "react-router-dom";

// const StyledBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   flexDirection: "row",
//   height: "100vh",
//   width: "100%",
//   backgroundColor: "#FFFFFF",
//   overflow: "hidden",
//   [theme.breakpoints.down("md")]: {
//     flexDirection: "column",
//   },
// }));

// const Split = styled(Box)(({ theme, side }) => ({
//   width: side === "left" ? "65%" : "35%",
//   height: "100%",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   background:
//     side === "left"
//       ? `linear-gradient(135deg, rgba(229, 238, 255, 0.9), rgba(255, 226, 230, 0.9))`
//       : "#F6F3F2",
//   [theme.breakpoints.down("md")]: {
//     width: "100%",
//     height: side === "left" ? "30%" : "70%",
//   },
// }));

// const LoginCard = styled(Box)(({ theme }) => ({
//   borderRadius: 0,
//   padding: "48px 24px",
//   backgroundColor: "transparent",
//   boxShadow: "none",
//   border: "none",
//   width: "100%",
//   maxWidth: "520px",
//   margin: "20px",
// }));

// const LogoContainer = styled(Box)({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-start",
//   paddingBottom: "16px",
//   borderBottom: "1px solid #E5E7EB",
//   marginBottom: "24px",
// });

// const Title = styled(Typography)({
//   fontSize: "32px",
//   color: "#333",
//   textAlign: "left",
//   marginBottom: "4px",
// });

// const Subtitle = styled(Typography)({
//   fontSize: "14px",
//   color: "#666",
//   textAlign: "left",
//   marginBottom: "24px",
// });

// const StyledTextField = styled(TextField)({
//   marginBottom: "18px",
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     backgroundColor: "#EFF4FF",
//   },
//   "& .MuiOutlinedInput-input": {
//     height: "22px",
//     padding: "14px 16px",
//   },
// });

// const StyledButton = styled(Button)({
//   borderRadius: "12px",
//   height: 52,
//   padding: "0 20px",
//   fontSize: "16px",
//   fontWeight: "700",
//   textTransform: "none",
//   marginTop: "16px",
//   boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
// });

// function Login() {
//   const [formValues, setFormValues] = useState({ username: "", password: "" });
//   const [showPassword, setShowPassword] = useState(false);
//   const [formErrors, setFormErrors] = useState({});
//   const [error, setError] = useState("");
//   const [severity, setSeverity] = useState("error");

//   const navigate = useNavigate();

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   const handleInputChange = (event) => {
//     const { id, value } = event.target;
//     setFormValues({
//       ...formValues,
//       [id]: value,
//     });
//     setFormErrors({
//       ...formErrors,
//       [id]: value.trim() ? "" : formErrors[id],
//     });
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     const username = document.getElementById("username").value;
//     const password = document.getElementById("password").value;

//     const errors = {};
//     if (!username.trim()) {
//       errors["username"] = "Please enter username.";
//     }
//     if (!password.trim()) {
//       errors["password"] = "Please enter password.";
//     }

//     setFormErrors(errors);

//     if (Object.keys(errors).length > 0) {
//       return;
//     }

//     try {
//       await login({ username: username.toString().toLowerCase(), password });
//       setSeverity("success");
//       navigate("/dashboard");
//     } catch (error) {
//       setSeverity("error");
//       setError(error.response?.data?.message || "Login failed. Please try again.");
//     }
//   };

//   return (
//     <StyledBox sx={{ display: "flex", width: "100%" }}>
//       <Split side="left">
//         <Box sx={{ width: "72%", color: "#1F2937" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//             <Box sx={{
//               width: 48,
//               height: 48,
//               borderRadius: "50%",
//               backgroundColor: "#E6F2FF",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 24,
//             }}>
//               🙂
//             </Box>
//           </Box>
//           <Typography variant="body2" sx={{ color: "#6B7280", mb: 2 }}>
//             Trust First. Risk Aware. Enterprise Ready
//           </Typography>
//           <Box sx={{ height: 1, backgroundColor: "#E5E7EB", mb: 4 }} />
//           <Typography variant="h4" sx={{ fontWeight: 700, lineHeight: 1.3, mb: 3 }}>
//             End-to-end GenAI compliance platform for testing, validating, and governing AI systems aligned with
//           </Typography>
//           <Typography variant="h5" sx={{ fontWeight: 600 }}>
//             <Box component="span" sx={{ color: "#1976d2" }}>NIST AI RMF</Box> and <Box component="span" sx={{ color: "#1976d2" }}>EU AI Act TEVV</Box>.
//           </Typography>
//         </Box>
//       </Split>

//       <Split side="right">
//         <LoginCard>
//           <LogoContainer>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//               <Box sx={{
//                 width: 32,
//                 height: 32,
//                 borderRadius: "50%",
//                 backgroundColor: "#E6F2FF",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 18,
//               }}>🙂</Box>
//               <Typography variant="h5" sx={{ fontWeight: 800 }}>
//                 Valid
//                 <Box component="span" sx={{ color: "#1976d2" }}>Aite</Box>
//               </Typography>
//             </Box>
//           </LogoContainer>

//           <Title>Welcome!</Title>
//           <Subtitle>Please enter your details</Subtitle>

//           {error && (
//             <Alert severity={severity} sx={{ mb: 2 }}>
//               {error}
//             </Alert>
//           )}

//           <form onSubmit={handleLogin}>
//             <StyledTextField
//               id="username"
//               label="Email ID"
//               placeholder="placeholder"
//               variant="outlined"
//               fullWidth
//               value={formValues.username}
//               onChange={handleInputChange}
//               error={!!formErrors.username}
//               helperText={formErrors.username}
//               autoComplete="username"
//             />

//             <StyledTextField
//               id="password"
//               label="Password"
//               placeholder="placeholder"
//               type={showPassword ? "text" : "password"}
//               variant="outlined"
//               fullWidth
//               value={formValues.password}
//               onChange={handleInputChange}
//               error={!!formErrors.password}
//               helperText={formErrors.password}
//               autoComplete="current-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label="toggle password visibility"
//                       onClick={handleClickShowPassword}
//                       onMouseDown={handleMouseDownPassword}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mt: 1 }}>
//               <FormControlLabel control={<Checkbox size="small" />} label={<Typography variant="body2" sx={{ color: "#6B7280" }}>Keep me signed in</Typography>} />
//               <StyledButton
//                 type="submit"
//                 variant="contained"
//                 endIcon={<ArrowForwardIcon />}
//                 sx={{
//                   px: 3,
//                   background: "linear-gradient(90deg, #1D72E7 0%, #2EA0FF 100%)",
//                   "&:hover": {
//                     background: "linear-gradient(90deg, #1862c5 0%, #2388da 100%)",
//                   },
//                 }}
//               >
//                 Login
//               </StyledButton>
//             </Box>

//             <Box sx={{ mt: 1 }}>
//               <Link component="button" type="button" underline="none" sx={{ fontSize: 12, color: "#1976d2" }}
//                 onClick={() => {}}>
//                 Forgot your password?
//               </Link>
//             </Box>
//           </form>
//           <Box sx={{ textAlign: "center", mt: 3, color: "#6B7280" }}>
//             <Typography variant="caption">
//               By signing in, you agree to our <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>Terms of Use</Link> & <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>Privacy Policy</Link>
//             </Typography>
//           </Box>
//         </LoginCard>
//       </Split>
//     </StyledBox>
//   );
// }

// export default Login;

// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Alert,
//   Checkbox,
//   FormControlLabel,
//   Link,
// } from "@mui/material";
// import { styled } from "@mui/system";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import { login } from "../services/webServices";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { setUser } from "../store/slices/authSlice";

// // ✅ Import your SVG assets
// import logo from "../asserts/logo/Logo.svg"
// import icon from "../asserts/logo/Icon.svg";
// import shadows from "@mui/material/styles/shadows";

// const StyledBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   flexDirection: "row",
//   height: "100vh",
//   width: "100%",
//   backgroundColor: "#FFFFFF",
//   overflow: "hidden",
//   [theme.breakpoints.down("md")]: {
//     flexDirection: "column",
//   },
// }));

// const Split = styled(Box)(({ theme, side }) => ({
//   width: side === "left" ? "65%" : "35%",
//   height: "100%",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   background:
//     side === "left"
//       ? `linear-gradient(135deg, rgba(229, 238, 255, 0.9), rgba(255, 226, 230, 0.9))`
//       : "#F6F3F2",
//   [theme.breakpoints.down("md")]: {
//     width: "100%",
//     height: side === "left" ? "30%" : "70%",
//   },
// }));

// const LoginCard = styled(Box)(({ theme }) => ({
//   borderRadius: 0,
//   padding: "48px 24px",
//   backgroundColor: "transparent",
//   boxShadow: "none",
//   border: "none",
//   width: "100%",
//   maxWidth: "520px",
//   margin: "20px",
// }));

// const LogoContainer = styled(Box)({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-start",
//   paddingBottom: "16px",
//   borderBottom: "1px solid #E5E7EB",
//   marginBottom: "24px",
// });

// const Title = styled(Typography)({
//   fontSize: "32px",
//   color: "#333",
//   textAlign: "left",
//   marginBottom: "4px",
// });

// const Subtitle = styled(Typography)({
//   fontSize: "14px",
//   color: "#666",
//   textAlign: "left",
//   marginBottom: "24px",
// });

// const StyledTextField = styled(TextField)({
//   marginBottom: "18px",
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "4px",
//     backgroundColor: "#EFF4FF",
//   },
//   "& .MuiOutlinedInput-input": {
//     height: "22px",
//     padding: "14px 16px",
//   },
// });

// const StyledButton = styled(Button)({
//   backgroundColor: "#0094fb",     
//   borderRadius: "6px",
//   height: 40,
//   padding: "0 20px",
//   fontSize: "16px",
//   fontWeight: "700",
//   textTransform: "none",
//   marginTop: "16px",
// });


// function Login() {
//   const [formValues, setFormValues] = useState({ username: "", password: "" });
//   const [showPassword, setShowPassword] = useState(false);
//   const [formErrors, setFormErrors] = useState({});
//   const [error, setError] = useState("");
//   const [severity, setSeverity] = useState("error");

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   const handleInputChange = (event) => {
//     const { id, value } = event.target;
//     setFormValues({
//       ...formValues,
//       [id]: value,
//     });
//     setFormErrors({
//       ...formErrors,
//       [id]: value.trim() ? "" : formErrors[id],
//     });
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     const username = document.getElementById("username").value;
//     const password = document.getElementById("password").value;

//     const errors = {};
//     if (!username.trim()) {
//       errors["username"] = "Please enter username.";
//     }
//     if (!password.trim()) {
//       errors["password"] = "Please enter password.";
//     }

//     setFormErrors(errors);

//     if (Object.keys(errors).length > 0) {
//       return;
//     }

//     try {
//       const response = await login({ username: username.toString().toLowerCase(), password });

//       // Store user data in Redux
//       if (response.data && response.data.user) {
//         dispatch(setUser(response.data.user));
//       }

//       setSeverity("success");
//       navigate("/projects");
//     } catch (error) {
//       setSeverity("error");
//       setError(error.response?.data?.message || "Login failed. Please try again.");
//     }
//   };

//   return (
//     <StyledBox sx={{ display: "flex", width: "100%" }}>
//       {/* === Left Side === */}
//       <Split side="left">
//         <Box sx={{ width: "72%", color: "#1F2937" }}>
//           {/* ✅ Replace emoji with icon.svg */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 4, mt: 10 }}>
//             <Box
//               component="img"
//               src={icon}
//               alt="Icon"
//               sx={{ width: 100, height: 80 }}
//             />
//           </Box>


//           <Typography variant="body2" sx={{ fontWeight: 520, mb: 3, fontSize: "28px" }}>
//             Trust First. Risk Aware. Enterprise Ready
//           </Typography>

//           <Box
//             sx={{
//               // width: "100%",
//               maxWidth: "80%", 
//               height: "1px",
//               backgroundColor: "#D1D5DB",
//               my: 3,
//             }}
//           />

//           <Typography
//             variant="h4"
//             sx={{ fontWeight: 550, mb: 1, fontSize: "28px" }}
//           >
//             QE -First AI Trust Engineering Platform Built for Enterprise IT.
//           </Typography>

//           {/* <Typography variant="h5" sx={{ fontWeight: 400 }}>
//             <Box component="span" sx={{ color: "#1976d2" }}>NIST AI RMF</Box> and <Box component="span" sx={{ color: "#1976d2" }}>EU AI Act TEVV</Box>.
//           </Typography> */}
//         </Box>
//       </Split>

//       {/* === Right Side === */}
//       <Split side="right">
//         <LoginCard>
//           <LogoContainer>
//             <Box sx={{ display: "flex", alignItems: "left", gap: 1 }}>
//               {/* ✅ Replace emoji with logo.svg */}
//               <Box
//                 component="img"
//                 src={logo}
//                 alt="ValidAite Logo"
//                 sx={{ width: 300, height: "auto", objectFit: "contain" }}
//               />
//             </Box>
//           </LogoContainer>

//           <Title>Welcome!</Title>
//           <Subtitle>Please enter your details</Subtitle>

//           {error && (
//             <Alert severity={severity} sx={{ mb: 2 }}>
//               {error}
//             </Alert>
//           )}

//           <form onSubmit={handleLogin}>
//             <StyledTextField
//               id="username"
//               label="Email ID"
//               placeholder="placeholder"
//               variant="outlined"
//               fullWidth
//               value={formValues.username}
//               onChange={handleInputChange}
//               error={!!formErrors.username}
//               helperText={formErrors.username}
//               autoComplete="username"
//             />

//             <StyledTextField
//               id="password"
//               label="Password"
//               placeholder="placeholder"
//               type={showPassword ? "text" : "password"}
//               variant="outlined"
//               fullWidth
//               value={formValues.password}
//               onChange={handleInputChange}
//               error={!!formErrors.password}
//               helperText={formErrors.password}
//               autoComplete="current-password"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label="toggle password visibility"
//                       onClick={handleClickShowPassword}
//                       onMouseDown={handleMouseDownPassword}
//                       edge="end"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mt: 1 }}>
//               <FormControlLabel
//                 control={<Checkbox size="small" />}
//                 label={
//                   <Typography variant="body2" sx={{ color: "#6B7280" }}>
//                     Keep me signed in
//                   </Typography>
//                 }
//               />
//               <StyledButton
//                 type="submit"
//                 variant="contained"
//                 endIcon={<ArrowForwardIcon />}
//                 sx={{
//                   mt: 3,
//                   fontWeight: 400,   // 👈 NOT bold anymore
//                   textTransform: "none",
//                   background: "#0094fb",
//                   "&:hover": {
//                    background: "#0094fb",
//                   //  shadows : 
//                   },
//                 }}
//               >
//                 Login
//               </StyledButton>

//             </Box>

//             <Box sx={{ mt: 1 }}>
//               <Link
//                 component="button"
//                 type="button"
//                 underline="none"
//                 sx={{ fontSize: 12, color: "#0094fb" }}
//                 onClick={() => {}}
//               >
//                 Forgot your password?
//               </Link>
//             </Box>
//           </form>

//           <Box sx={{ textAlign: "center", mt: 3, color: "#6B7280" }}>
//             {/* <Typography variant="caption">
//               By signing in, you agree to our{" "}
//               <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>
//                 Terms of Use
//               </Link>{" "}
//               &{" "}
//               <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>
//                 Privacy Policy
//               </Link>
//             </Typography> */}
//           </Box>
//         </LoginCard>
//       </Split>
//     </StyledBox>
//   );
// }

// export default Login;

// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   TextField,
// //   Button,
// //   IconButton,
// //   InputAdornment,
// //   Alert,
// //   Checkbox,
// //   FormControlLabel,
// //   Link,
// // } from "@mui/material";
// // import { styled } from "@mui/system";
// // import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// // import Visibility from "@mui/icons-material/Visibility";
// // import VisibilityOff from "@mui/icons-material/VisibilityOff";
// // import { login } from "../services/webServices";
// // import { useNavigate } from "react-router-dom";

// // const StyledBox = styled(Box)(({ theme }) => ({
// //   display: "flex",
// //   flexDirection: "row",
// //   height: "100vh",
// //   width: "100%",
// //   backgroundColor: "#FFFFFF",
// //   overflow: "hidden",
// //   [theme.breakpoints.down("md")]: {
// //     flexDirection: "column",
// //   },
// // }));

// // const Split = styled(Box)(({ theme, side }) => ({
// //   width: side === "left" ? "65%" : "35%",
// //   height: "100%",
// //   display: "flex",
// //   justifyContent: "center",
// //   alignItems: "center",
// //   background:
// //     side === "left"
// //       ? `linear-gradient(135deg, rgba(229, 238, 255, 0.9), rgba(255, 226, 230, 0.9))`
// //       : "#F6F3F2",
// //   [theme.breakpoints.down("md")]: {
// //     width: "100%",
// //     height: side === "left" ? "30%" : "70%",
// //   },
// // }));

// // const LoginCard = styled(Box)(({ theme }) => ({
// //   borderRadius: 0,
// //   padding: "48px 24px",
// //   backgroundColor: "transparent",
// //   boxShadow: "none",
// //   border: "none",
// //   width: "100%",
// //   maxWidth: "520px",
// //   margin: "20px",
// // }));

// // const LogoContainer = styled(Box)({
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "flex-start",
// //   paddingBottom: "16px",
// //   borderBottom: "1px solid #E5E7EB",
// //   marginBottom: "24px",
// // });

// // const Title = styled(Typography)({
// //   fontSize: "32px",
// //   color: "#333",
// //   textAlign: "left",
// //   marginBottom: "4px",
// // });

// // const Subtitle = styled(Typography)({
// //   fontSize: "14px",
// //   color: "#666",
// //   textAlign: "left",
// //   marginBottom: "24px",
// // });

// // const StyledTextField = styled(TextField)({
// //   marginBottom: "18px",
// //   "& .MuiOutlinedInput-root": {
// //     borderRadius: "12px",
// //     backgroundColor: "#EFF4FF",
// //   },
// //   "& .MuiOutlinedInput-input": {
// //     height: "22px",
// //     padding: "14px 16px",
// //   },
// // });

// // const StyledButton = styled(Button)({
// //   borderRadius: "12px",
// //   height: 52,
// //   padding: "0 20px",
// //   fontSize: "16px",
// //   fontWeight: "700",
// //   textTransform: "none",
// //   marginTop: "16px",
// //   boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
// // });

// // function Login() {
// //   const [formValues, setFormValues] = useState({ username: "", password: "" });
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [formErrors, setFormErrors] = useState({});
// //   const [error, setError] = useState("");
// //   const [severity, setSeverity] = useState("error");

// //   const navigate = useNavigate();

// //   const handleClickShowPassword = () => {
// //     setShowPassword(!showPassword);
// //   };

// //   const handleMouseDownPassword = (event) => {
// //     event.preventDefault();
// //   };

// //   const handleInputChange = (event) => {
// //     const { id, value } = event.target;
// //     setFormValues({
// //       ...formValues,
// //       [id]: value,
// //     });
// //     setFormErrors({
// //       ...formErrors,
// //       [id]: value.trim() ? "" : formErrors[id],
// //     });
// //   };

// //   const handleLogin = async (event) => {
// //     event.preventDefault();
// //     const username = document.getElementById("username").value;
// //     const password = document.getElementById("password").value;

// //     const errors = {};
// //     if (!username.trim()) {
// //       errors["username"] = "Please enter username.";
// //     }
// //     if (!password.trim()) {
// //       errors["password"] = "Please enter password.";
// //     }

// //     setFormErrors(errors);

// //     if (Object.keys(errors).length > 0) {
// //       return;
// //     }

// //     try {
// //       await login({ username: username.toString().toLowerCase(), password });
// //       setSeverity("success");
// //       navigate("/dashboard");
// //     } catch (error) {
// //       setSeverity("error");
// //       setError(error.response?.data?.message || "Login failed. Please try again.");
// //     }
// //   };

// //   return (
// //     <StyledBox sx={{ display: "flex", width: "100%" }}>
// //       <Split side="left">
// //         <Box sx={{ width: "72%", color: "#1F2937" }}>
// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
// //             <Box sx={{
// //               width: 48,
// //               height: 48,
// //               borderRadius: "50%",
// //               backgroundColor: "#E6F2FF",
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               fontSize: 24,
// //             }}>
// //               🙂
// //             </Box>
// //           </Box>
// //           <Typography variant="body2" sx={{ color: "#6B7280", mb: 2 }}>
// //             Trust First. Risk Aware. Enterprise Ready
// //           </Typography>
// //           <Box sx={{ height: 1, backgroundColor: "#E5E7EB", mb: 4 }} />
// //           <Typography variant="h4" sx={{ fontWeight: 700, lineHeight: 1.3, mb: 3 }}>
// //             End-to-end GenAI compliance platform for testing, validating, and governing AI systems aligned with
// //           </Typography>
// //           <Typography variant="h5" sx={{ fontWeight: 600 }}>
// //             <Box component="span" sx={{ color: "#1976d2" }}>NIST AI RMF</Box> and <Box component="span" sx={{ color: "#1976d2" }}>EU AI Act TEVV</Box>.
// //           </Typography>
// //         </Box>
// //       </Split>

// //       <Split side="right">
// //         <LoginCard>
// //           <LogoContainer>
// //             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// //               <Box sx={{
// //                 width: 32,
// //                 height: 32,
// //                 borderRadius: "50%",
// //                 backgroundColor: "#E6F2FF",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 fontSize: 18,
// //               }}>🙂</Box>
// //               <Typography variant="h5" sx={{ fontWeight: 800 }}>
// //                 Valid
// //                 <Box component="span" sx={{ color: "#1976d2" }}>Aite</Box>
// //               </Typography>
// //             </Box>
// //           </LogoContainer>

// //           <Title>Welcome!</Title>
// //           <Subtitle>Please enter your details</Subtitle>

// //           {error && (
// //             <Alert severity={severity} sx={{ mb: 2 }}>
// //               {error}
// //             </Alert>
// //           )}

// //           <form onSubmit={handleLogin}>
// //             <StyledTextField
// //               id="username"
// //               label="Email ID"
// //               placeholder="placeholder"
// //               variant="outlined"
// //               fullWidth
// //               value={formValues.username}
// //               onChange={handleInputChange}
// //               error={!!formErrors.username}
// //               helperText={formErrors.username}
// //               autoComplete="username"
// //             />

// //             <StyledTextField
// //               id="password"
// //               label="Password"
// //               placeholder="placeholder"
// //               type={showPassword ? "text" : "password"}
// //               variant="outlined"
// //               fullWidth
// //               value={formValues.password}
// //               onChange={handleInputChange}
// //               error={!!formErrors.password}
// //               helperText={formErrors.password}
// //               autoComplete="current-password"
// //               InputProps={{
// //                 endAdornment: (
// //                   <InputAdornment position="end">
// //                     <IconButton
// //                       aria-label="toggle password visibility"
// //                       onClick={handleClickShowPassword}
// //                       onMouseDown={handleMouseDownPassword}
// //                       edge="end"
// //                     >
// //                       {showPassword ? <VisibilityOff /> : <Visibility />}
// //                     </IconButton>
// //                   </InputAdornment>
// //                 ),
// //               }}
// //             />

// //             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mt: 1 }}>
// //               <FormControlLabel control={<Checkbox size="small" />} label={<Typography variant="body2" sx={{ color: "#6B7280" }}>Keep me signed in</Typography>} />
// //               <StyledButton
// //                 type="submit"
// //                 variant="contained"
// //                 endIcon={<ArrowForwardIcon />}
// //                 sx={{
// //                   px: 3,
// //                   background: "linear-gradient(90deg, #1D72E7 0%, #2EA0FF 100%)",
// //                   "&:hover": {
// //                     background: "linear-gradient(90deg, #1862c5 0%, #2388da 100%)",
// //                   },
// //                 }}
// //               >
// //                 Login
// //               </StyledButton>
// //             </Box>

// //             <Box sx={{ mt: 1 }}>
// //               <Link component="button" type="button" underline="none" sx={{ fontSize: 12, color: "#1976d2" }}
// //                 onClick={() => {}}>
// //                 Forgot your password?
// //               </Link>
// //             </Box>
// //           </form>
// //           <Box sx={{ textAlign: "center", mt: 3, color: "#6B7280" }}>
// //             <Typography variant="caption">
// //               By signing in, you agree to our <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>Terms of Use</Link> & <Link underline="hover" href="#" sx={{ color: "#1976d2" }}>Privacy Policy</Link>
// //             </Typography>
// //           </Box>
// //         </LoginCard>
// //       </Split>
// //     </StyledBox>
// //   );
// // }

// // export default Login;
